import { Action } from '@ngrx/store';
import { File } from '../../../vas/business-objects/file/file.model';

export const INIT = '[FileManager] Init';
export const INIT_SUCCESS = '[FileManager] Init Success';
export const INIT_FAIL = '[FileManager] Init Fail';
export const CREATE_FROM_BLOBS = '[FileManager] Create from Blob';
export const CREATE_FROM_BLOBS_SUCCESS = '[FileManager] Create from Blob Success';
export const CREATE_FROM_BLOBS_FAIL = '[FileManager] Create from Blob Fail';
export const ADD_FILES = '[FileManager] Create from Uris Success';
export const CREATE_FROM_URIS_FAIL = '[FileManager] Create from Uris Fail';
export const DOWNLOAD_FILE = '[FileManager] Download';
export const UPDATE = '[FileManager] Update';
export const REMOVE = '[FileManager] Remove';
export const REMOVE_SELECTED = '[FileManager] Remove Selected';
export const REORDER = '[FileManager] Reorder';
export const RESET = '[FileManager] RESET';
export const ROTATE_LEFT = '[FileManager] Rotate Left';
export const ROTATE_RIGHT = '[FileManager] Rotate Right';
export const SELECT_ALL = '[FileManager] Select All';
export const SELECT_NONE = '[FileManager] Select None';
export const SET_SELECTED = '[FileManager] Set Selected';
export const SET_GROUP_FOR_SELECTED = '[FileManager] Set Group for Selected';
export const SET_FILTER_GROUP = '[FileManager] Set Filter Group';
export const SET_FILTER_SEARCH_TERM = '[FileManager] Set Filter Search Term';
export const TOGGLE_DISPLAY_AS_ACTION = '[FileManager] Toggle Display As';
export const VIEW_FILE = '[FileManager] View File';

export class InitAction implements Action {
    readonly type = INIT;

    constructor(public payload: {jobId: string}) {

    }
}

export class InitSuccessAction implements Action {
    readonly type = INIT_SUCCESS;

    constructor(public payload: {files: Array<File>}) {

    }
}

export class InitFailAction implements Action {
    readonly type = INIT_FAIL;

    constructor(public payload: {error: Error}) {

    }
}

export class CreateFromBlobsAction implements Action {
    readonly type = CREATE_FROM_BLOBS;

    constructor(public payload: {blobs: Array<Blob>, accountId: string, jobId: string, group: string}) {

    }
}

export class CreateFromBlobsSuccessAction implements Action {
    readonly type = CREATE_FROM_BLOBS_SUCCESS;

    constructor(public payload: {files: Array<File>}) {

    }
}

export class CreateFromBlobsFailAction implements Action {
    readonly type = CREATE_FROM_BLOBS_FAIL;

    constructor(public payload: {error: Error}) {

    }
}

export class AddFilesAction implements Action {
    readonly type = ADD_FILES;

    constructor(public payload: {files: Array<File>}) {

    }
}

export class CreateFromUrisFailAction implements Action {
    readonly type = CREATE_FROM_URIS_FAIL;

    constructor(public payload: {error: Error}) {

    }
}

export class DownloadFileAction implements Action {
    readonly type = DOWNLOAD_FILE;

    constructor(public payload: {file: File}) {

    }
}

export class UpdateAction implements Action {
    readonly type = UPDATE;

    constructor(public payload: {file: File}) {

    }
}

export class RemoveAction implements Action {
    readonly type = REMOVE;

    constructor(public payload: {file: File}) {

    }
}

export class RemoveSelectedAction implements Action {
    readonly type = REMOVE_SELECTED;
}

export class ReorderAction implements Action {
    readonly type = REORDER;

    constructor(public payload: {from: number, to: number}) {

    }
}

export class ResetAction implements Action {
    readonly type = RESET;
}

export class RotateLeftAction implements Action {
    readonly type = ROTATE_LEFT;

    constructor(public payload: {file: File}) {

    }
}

export class RotateRightAction implements Action {
    readonly type = ROTATE_RIGHT;

    constructor(public payload: {file: File}) {

    }
}

export class SelectAllAction implements Action {
    readonly type = SELECT_ALL;
}

export class SelectNoneAction implements Action {
    readonly type = SELECT_NONE;
}

export class SetSelectedAction implements Action {
    readonly type = SET_SELECTED;

    constructor(public payload: {file: File, selected: boolean}) {

    }
}

export class SetGroupForSelectedAction implements Action {
    readonly type = SET_GROUP_FOR_SELECTED;

    constructor(public payload: {group: string}) {

    }

}

export class SetFilterGroupAction implements Action {
    readonly type = SET_FILTER_GROUP;

    constructor(public payload: {groups: Array<string>}) {

    }
}

export class SetFilterSearchTermAction implements Action {
    readonly type = SET_FILTER_SEARCH_TERM;

    constructor(public payload: {searchTerm: string}) {

    }
}

export class ToggleDisplayAsAction implements Action {
    readonly type = TOGGLE_DISPLAY_AS_ACTION;

    constructor(public payload: {file: File}) {
    }
}

export class ViewFileAction implements Action {
    readonly type = VIEW_FILE;

    constructor(public payload: {file: File}) {
    }
}

export declare type Actions
    = InitAction
    | InitSuccessAction
    | InitFailAction
    | CreateFromBlobsAction
    | CreateFromBlobsSuccessAction
    | CreateFromBlobsFailAction
    | AddFilesAction
    | CreateFromUrisFailAction
    | DownloadFileAction
    | UpdateAction
    | ReorderAction
    | RemoveAction
    | RemoveSelectedAction
    | ResetAction
    | RotateLeftAction
    | RotateRightAction
    | SelectAllAction
    | SelectNoneAction
    | SetSelectedAction
    | SetGroupForSelectedAction
    | SetFilterGroupAction
    | SetFilterSearchTermAction
    | ToggleDisplayAsAction
    | ViewFileAction
    ;



// WEBPACK FOOTER //
// ./src/app/molecules/file-manager/file-manager.actions.ts